module.exports = __webpack_public_path__ + "static/media/ubahn-echtzeit.be98958a.svg";